import { options } from 'js/features/apply_chosen';

function addFxRatesToDropdown(fxRates, selectedFxRate) {
  $.each(fxRates, function (_fxRateIndex, fxRate) {
    var option = $('<option/>').attr('value', fxRate[1]).text(fxRate[0]);

    if (fxRate[1] === Number(selectedFxRate)) {
      option.attr('selected', 'selected');
    }

    $('#fx-rate-id').append(option);
  });
}

function updateFxRateDropdown(fxRates) {
  var emptyValue = '<option value="">' + I18n.t('javascript.options.please_select') + '</option>';
  var $fxRateId = $('#fx-rate-id');
  var selectedFxRate = $fxRateId.find('option:selected').val();
  $fxRateId.empty();
  $fxRateId.append(emptyValue);
  addFxRatesToDropdown(fxRates, selectedFxRate);
  $fxRateId.addClass('for_chosen').chosen(options);
  $fxRateId.trigger('chosen:updated');
}

function updateFxRateSelect(fx_data) {
  var merchantSupportsFx = fx_data.merchant_supports_fx;

  if (merchantSupportsFx) {
    updateFxRateDropdown(fx_data.fx_rates);
    $('#fx_rate_params').removeClass('hidden');
  } else {
    $('#fx_rate_params').addClass('hidden');
  }
}

var FxRates = {
  updateFxRateSelect: updateFxRateSelect
};
export default FxRates;